import { format, parseISO } from "date-fns";

export default function addMaskDateAndHour(date: string) {
  const dateParsed = parseISO(date);

  return format(dateParsed, "dd/MM/yyyy HH:mm");
}
